import { ref, watch } from 'vue-demi';

const currentRoute = ref({});

export default function useRouteManager({ context, legacyConnector }) {
  // Because vue-router v3 doesnt support vue-composition-api,
  // we need to watch the route at the root of the app
  // and inject it via the appFacade
  watch(
    () => context.root.$route,
    (route) => {
      currentRoute.value = route;
    },
    { immediate: true }, // needs to happen on init
  );

  const push = (path = '#') => {
    legacyConnector.check();

    const route = typeof path === 'string' ? { path } : path;

    if (legacyConnector.isLegacyConnected.value) {
      window.parent.document.location.href = context.root.$router
        .resolve(route)
        .href.replace('/next/', '/#/');
      return;
    }

    context.root.$router.push(route);
  };

  // more route related shenanigans
  return {
    currentRoute,
    push,
  };
}
